
class Test {


}

window.test = new Test();
